/**
 * ONIX list 158 content types 01–10 (covers, contributor pictures and the
 * series/product/publisher/imprint images and logos) are images.
 */
export var IMAGE_RESOURCE_TYPE_VALUES = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
];
/** ONIX list 159 resource mode "03" = Image. */
export var IMAGE_MODE_VALUE = "03";
/** Extensions an image-type resource link must end with (lower-case). */
export var IMAGE_LINK_EXTENSIONS = [
    "jpg",
    "jpeg",
    "png",
    "gif",
];
/** Upload MIME types accepted for resource images. */
export var IMAGE_UPLOAD_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/gif",
];
/** ONIX list 158 content type "01" = Front cover. */
export var FRONT_COVER_TYPE_VALUE = "01";
/**
 * ONIX list 158 content type "25" = Table of contents; its link must point to
 * a PDF file (issue #75957).
 */
export var TABLE_OF_CONTENTS_TYPE_VALUE = "25";
/** ONIX list 159 resource mode "04" = Text. */
export var TEXT_MODE_VALUE = "04";
/** Extensions a table-of-contents link must end with (lower-case). */
export var PDF_LINK_EXTENSIONS = ["pdf"];
/** Upload MIME types accepted for a table of contents. */
export var PDF_UPLOAD_MIME_TYPES = ["application/pdf"];
/** Upload limits — mirror of the backend StorageService. */
export var IMAGE_UPLOAD_MAX_BYTES = 5 * 1024 * 1024;
export var PDF_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
export var isImageResourceType = function (type) {
    return !!(type === null || type === void 0 ? void 0 : type.value) && IMAGE_RESOURCE_TYPE_VALUES.includes(type.value);
};
/** True when an image-type resource does not (yet) carry the Image mode. */
export var requiresImageMode = function (type, mode) {
    return isImageResourceType(type) && (mode === null || mode === void 0 ? void 0 : mode.value) !== IMAGE_MODE_VALUE;
};
/**
 * Checks the file extension of the link path — the query string and fragment
 * are ignored and the comparison is case-insensitive. Plain string handling on
 * purpose: the backend applies the very same rule.
 */
var hasLinkExtension = function (link, extensions) {
    var _a;
    var trimmed = (_a = link === null || link === void 0 ? void 0 : link.trim()) !== null && _a !== void 0 ? _a : "";
    var path = trimmed.split(/[?#]/, 1)[0];
    var fileName = path.slice(path.lastIndexOf("/") + 1);
    var dot = fileName.lastIndexOf(".");
    if (dot < 0)
        return false;
    return extensions.includes(fileName.slice(dot + 1).toLowerCase());
};
export var hasImageLinkExtension = function (link) {
    return hasLinkExtension(link, IMAGE_LINK_EXTENSIONS);
};
export var isTableOfContentsType = function (type) {
    return (type === null || type === void 0 ? void 0 : type.value) === TABLE_OF_CONTENTS_TYPE_VALUE;
};
/** Same path rules as {@link hasImageLinkExtension}, for a .pdf file. */
export var hasPdfLinkExtension = function (link) {
    return hasLinkExtension(link, PDF_LINK_EXTENSIONS);
};
/**
 * Which file the resource modal lets the user upload. The type decides first:
 * a table of contents always takes a PDF (whatever the mode, otherwise an
 * uploaded image would then fail the PDF link rule); otherwise the Image mode
 * takes an image, as before.
 */
export var resolveUploadKind = function (type, mode) {
    if (isTableOfContentsType(type))
        return "pdf";
    if ((mode === null || mode === void 0 ? void 0 : mode.value) === IMAGE_MODE_VALUE)
        return "image";
    return null;
};
